<template>
  <path pid="0" d="M19 22a6 6 0 006-5.87v-.26A6 6 0 0019 10h-.52A9 9 0 1010 22zM3 13.59a7 7 0 0113.75-2.34 1 1 0 001 .75H19a4 4 0 010 8h-9a7 7 0 01-7-6.41z"/>
</template>
